<template>
	<div id="container" class="page-container" @click="categoryPageClick" v-if="showFlag">
		<a-spin :spinning="reloadSpinning">
			<div>
				<!-- <Font @setOffsetTop="setOffsetTop"></Font> -->
				<div :style="scrolldiv" @scroll="handleScroll" class="scrolldiv weekscroll" ref="scrolldivRef">


						<div class="banner-area">
							<div class="banner-card">
								<div class="banner-left">
									<div class="icon-round">
										<img
											src="https://enplus.oss-cn-guangzhou.aliyuncs.com/file/66cc65b6-d3fe-40a8-ada9-8c78bdd5bdd2.png" />
									</div>
								</div>
								<div class="banner-right">
									<div class="banner-title">{{ extractedData.articleTitle }}</div>

								</div>
							</div>

							<div class="tabs" style="align-items: center;">
								<div v-for="(t, i) in tabs" :key="i" class="tab" :class="{ active: activeTab === i }"
									@click="activeTab = i">
									{{ t }}
								</div>
								<a-button @click="toCopy"  style="font-size: 13px;
    background: #06a1a3;
    color: white;
    border-radius: 10px;
    padding: 2px 8px;">复制全文</a-button>
							</div>
						</div>

						<div class="list-area" style="padding:5px 40px 40px 40px">
							<!-- 分节头 + 可折叠卡片列表视图（与设计图一致） -->
							<div v-for="(section, idx) in previewCards" :key="idx" class="section-block">
								<template v-if="section.sectionshow">
								<div class="section-header">
									<div class="section-left">
										<div class="mark"></div>

										<div class="section-title-text">{{ section.preTitle }}</div>
									</div>

								</div>

								<div class="cards-container" >
									<!-- 预览模式下使用图片中的静态卡片数据（数组驱动渲染） -->
									<div class="cards-inner">
										<div v-for="(card, cardIdx) in section.children" :key="cardIdx"
											:data-idx="cardIdx" >
											<template v-if="card.items && card.items.length > 0">
												<div class="section-header" :key="itemIdx" >
													<div class="section-left">
														<template v-if="card.subTitle&&card.subTitle!=''">
															<div class="mark"></div>

														<div class="section-title-text">{{ card.subTitle }}</div>
														</template>
														<UpOutlined @click="card.subTitleShow = false"  style="margin-left: auto;" v-if="card.subTitleShow"/>
													
													   <DownOutlined @click="card.subTitleShow = true" style="margin-left: auto;" v-else/>
													</div>


												</div>
												<template v-if="card.subTitleShow">
													<div v-for="(value, valueIndex) in card.items" :key="valueIndex">
													<div :class="{ expanded: value.expanded,'report-card':true }">
														<div>
															<text class="pill-tag" v-if="value.tag!=null && value.tag!=''">{{ value.tag }}</text>
															<text class="card-title">{{ value.title }}</text>
														</div>
														<p style="font-size:16px;text-align: justify;" :ref="(el) => setTextRef(el, 1, idx, valueIndex)">{{
															value.content }}</p>

														<a v-if="value.show"
															:class="['expand-btn', value.expanded ? 'disexpand-btn' : '']"
															href="javascript:;"
															@click.prevent="toggleCardExpand(1, idx, valueIndex)">
															{{ value.expanded ? '收起全文' : '展开全文' }}
														</a>
														<div class="meta" >
															<template v-if="value.sources.length > 0">
<template v-for="(m, mi) in value.sources">
																<span v-if="mi !== 0" class="dot"></span>
																<img style="    width: 20px;" v-else
																	src="https://enplus.oss-cn-guangzhou.aliyuncs.com/file/3a71c59b-a645-48f9-b04f-5a14d63e1f11.png">
																<span>{{ m.title }}</span>
																<span>{{ m.time }}</span>

															</template>
															</template>
															


															<div v-if="value.links != ''" v-html="value.links"
																ref="htmlContainer"
																@click.stop="aiContentClick($event)"></div>


														</div>

													</div>
												</div>
												</template>
											</template>
											<template v-else>
												<div :class="{ expanded: card.expanded,'report-card':true }">
													<div>
														<text class="pill-tag" v-if="card.tag!=null && card.tag!=''">{{ card.tag }}</text>
														<text class="card-title">{{ card.subTitle }}</text>
													</div>
													<p style="font-size:16px;text-align: justify;" :ref="(el) => setTextRef(el, 0, idx)">{{ card.content }}</p>

													<a v-if="card.show"
														:class="['expand-btn', card.expanded ? 'disexpand-btn' : '']"
														href="javascript:;" @click.prevent="toggleCardExpand(0, idx)">
														{{ card.expanded ? '收起全文' : '展开全文' }}
													</a>



												</div>

											</template>

										</div>
									</div>


								</div>
								</template>
							</div>
							<div @click.stop="clickLinkArticle" id="linkArticle"
								:style='{ display: linkArticle.display, top: linkArticle.top, "z-index": linkArticle.index }'
								class="linkArticle">
								<div @click.stop="clickLinkArticleItem(linkitem)"
									style="display: flex;    align-items: center;"
									v-for="(linkitem, linkIndex) in linkList" v-bind:key="linkIndex">
									<div class="linkItem">{{ linkitem.index }}、{{ linkitem.title }}

									</div>
									<img :src="linkSrc" style="width: 15px;height: 15px;" />
								</div>

							</div>
							<div>小Q周报由AI自动生成，使用时请注意甄别。</div>
						</div>
				
				</div>
			</div>
		</a-spin>
	</div>
	<WeeklyArticleDetail1 v-else></WeeklyArticleDetail1>
</template>
<script>


import useClipboard from 'vue-clipboard3'
import $ from 'jquery'
import {UpOutlined,DownOutlined} from '@ant-design/icons-vue'
import Font from '../articleComponent/Font.vue'
import { toDoArticleRecord } from './js/index'
import { getLoginUserInfo } from '../../views/js/index'
import { useRouter } from 'vue-router';
import { guestArticle, readList } from '../articleComponent/js/index'
import { onMounted, watch, ref, onDeactivated, onActivated } from 'vue'
import store from '@/store';
import router from '@/router';
import { nextTick } from 'vue';
import WeeklyArticleDetail1 from './weeklyArticleDetail1.vue';
import { message } from 'ant-design-vue/lib/components.js'

export default {
	name: 'weeklyArticleDetail',
	components: { Font, WeeklyArticleDetail1, UpOutlined,DownOutlined },

	setup() {
		const showFlag=ref(true)
		watch(() => store.getters.fontSize, (val, oldVal) => {
			fontSize.value = val
			toGetResize(fontSize.value, oldVal, aiContent.value)

		})
		const $router = useRouter();
		watch(
			() => $router.currentRoute.value.query,
			(val, old) => {
				if ($router.currentRoute.value.path.indexOf('weeklyArticleDetail') > -1 && val && val.warticleId) {
					aiCategoryId.value = val.warticleId
					if (store.getters.companyList && store.getters.company) {
						var result = store.getters.companyList.find(item => item.companyId == store.getters.company.companyId)
						if (result) {
							todayImg.value = result.todayImg
							toShowDetail()
						}
						else {
							toGetUserInfor()
						}
					}
					else {
						toGetUserInfor()
					}
				}
				//如果不是文章返回的到文章列表 重置数据



			})
		onDeactivated(() => {


			toDoArticleRecord(aiCategoryId.value, 2)


		})
		onActivated(() => {

			fontSize.value = store.getters.fontSize
			toGetResize(fontSize.value, 2, aiContent.value)

			if (aiContent.value == null || aiContent.value == '') {
				if ($router.currentRoute.value.query.warticleId) {
					aiCategoryId.value = $router.currentRoute.value.query.warticleId
					if (store.getters.company) {
						todayImg.value = store.getters.company.todayImg

						toShowDetail()
					}
					else {
						toGetUserInfor()
					}
				}
			}

			document.querySelector('.scrolldiv').scrollTop = scrollY.value
		})
		const extractedData = ref('')

		const previewCards = ref([])


		const toShowDetail = async () => {
			activeTab.value = 0
			var height = document.getElementById('container').offsetHeight
			scrolldiv.value = { height: (height - 20) + 'px', overflow: 'auto' }
			reloadSpinning.value = true
			await guestArticle({ id: aiCategoryId.value }).then(async (res) => {
				 aiContent.value = res.data.content
				//aiContent.value="<div class=\"ai-category\" style=\"color:rgb(89,89,89);font-size:17px !important;line-height:1.75;letter-spacing:1px;text-align: justify;white-space: pre-line;\"><h2 style=\"font-size:17px !important;line-height:1.75;letter-spacing:1px;text-align: center;margin-bottom: 17px;\"><strong>2026年10月5日-2026年10月11日国际调味新观察</strong></h2><ul><li><text style=\"font-weight:bold\" class=\"autoParse\">一、海外行业发展综合动向</text></li><li>本批资料反映出海外食品行业正面临地缘政治合规、供应链重构与消费趋势升级的多重变局。首先，美国UFLPA实体清单扩容至思念、洽洽等民生食品企业，标志着贸易壁垒向基础农产品纵深蔓延，迫使中国企业加速供应链物理隔离与双向合规体系建设，同时欧盟CSDDD等法规的联动效应加剧了全球合规压力。其次，全球巨头通过并购（味好美合并联合利华食品）与产能优化（卡夫亨氏精简工厂）应对通胀与成本压力，行业集中度进一步提升。消费端呈现健康化与场景化双重趋势，减盐、清洁标签及无麸质产品成为主流，复合调味料凭借便捷性在B端餐饮与C端家庭场景持续高增长。此外，中国食品出口结构发生显著变化，俄罗斯市场因西方品牌退出迎来爆发式增长，而欧美市场对高端、功能性调味品需求旺盛，但同时也面临更严苛的标签与添加剂监管挑战。</li><li><text style=\"font-weight:bold\" class=\"autoParse\">1.1 贸易政策与经营环境</text><ul><li><text class=\"autoParse\" style=\"font-weight: bold;\">【市场研究】加州推行食品日期标签标准化以减少浪费</text>：加州通过AB 660法案，成为美国首个强制要求标准化消费者食品日期标签的州，规定使用特定术语区分质量与安全性日期，旨在解决消费者混淆导致的食品浪费问题。该法规虽仅适用于加州，但纽约等地也在推进类似立法，联邦层面亦在考虑全国性框架。此举标志着美国食品标签监管从行业自愿标准向强制性统一规范转变，制造商需调整标签策略以符合“Best if Used By”（质量）和“Use By”（安全）等新标准，这可能引发全美范围内的标签合规变革。（Nutritional Outlook，2026-10-09）<a href=\"/#/HomePage/editorPage?articleId=2034001\" data-title=\"（国际化）【境外消息】加州统一食品日期标签：首个全州强制规定及未来展望\" data-href=\"2034001\" data-index=\"1\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: rgb(0, 157, 166); background-color: rgb(255, 255, 255); border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">1</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【市场研究】FDA拟扩大有毒化学物质食品添加剂豁免范围</text>：美国FDA提议扩大“监管阈值”（TOR）豁免范围，允许某些非致癌但具有神经毒性或内分泌干扰性的有毒化学物质在极低浓度下直接作为食品添加剂使用，无需安全审查。专家警告此举基于 flawed science，忽视了低剂量累积危害及多种化学物质的协同效应，可能导致更多有害物质进入超加工食品。尽管FDA声称已关闭GRAS漏洞，但TOR扩张被视为对大型食品企业的让步，引发了公众健康倡导者对食品安全监管倒退的强烈担忧。（The Guardian，2026-10-10）<a href=\"/#/HomePage/editorPage?articleId=2033999\" data-title=\"（国际化）【境外消息】FDA 可能允许在不进行安全审查的情况下向食品中添加某些有毒化学物质。专家们对此深感担忧\" data-href=\"2033999\" data-index=\"2\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">2</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【市场研究】FDA修订139种食品标准以允许使用盐替代品</text>：为支持减钠目标，美国FDA发布最终规则，修订139种具有身份标准（SOI）的食品法规，允许使用盐替代品。此前这些食品标准规定必须或可选添加食盐，禁止使用替代品。新规赋予制造商灵活性，以降低高血压风险。然而，减钠可能影响肉类和奶酪等食品的防腐能力及保质期，需通过pH值调整或使用氯化钾等技术平衡食品安全与质量。此举 aligns with FDA自愿减钠目标，旨在逐步降低美国食品供应中的钠含量。（Food Safety Magazine，2026-10-09）<a href=\"/#/HomePage/editorPage?articleId=2033988\" data-title=\"（国际化）【境外消息】为支持减钠目标，FDA 修订了 139 种食品的标准化声明（SOIs），以允许使用盐替代品\" data-href=\"2033988\" data-index=\"3\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">3</a></li></ul></li><li><text style=\"font-weight:bold\" class=\"autoParse\">1.2 市场规模与增长趋势</text><ul><li><text style=\"font-weight: bold;\" class=\"autoParse\">【出口动态】中国酱油出口十年翻倍，欧洲成第一大区域</text>：2016-2025年，中国酱油出口量从12.7万吨增至24.8万吨，目的地扩至160个国家和地区。出口结构发生显著变化，欧洲以21.7%份额超越北美成为第一大出口区域，东南亚和非洲份额亦大幅上升，而港澳台及日韩份额下降。美国仍是最大单一市场，但份额被摊薄。出口均价回落至902美元/吨，呈现“量增价跌”特征。增长动力来自新兴市场如塞内加尔、越南等地的爆发式需求，显示中国酱油全球化布局从依赖传统市场向多元区域扩散。（微信-调味品商情，2026-10-07）<a href=\"/#/HomePage/editorPage?articleId=2031718\" data-title=\"（酱油、国际化）中国酱油出口十年:卖到160个国家和地区,欧洲超过北美\" data-href=\"2031718\" data-index=\"4\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">4</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【区域趋势】中国食品对俄出口爆发，填补西方品牌空缺</text>：2026年一季度中国对俄食品出口同比上涨21.1%，果蔬、复合调味品、方便速食等品类翻倍增长。西方品牌撤离留下百亿级市场空白，中国产品凭借高性价比和本土化改良快速进入俄罗斯主流商超及电商平台。口岸通关便利化及冷链物流优化提升了生鲜出口效率。然而，企业面临俄方法规频繁变动、跨境物流成本高企及本土竞争加剧等风险。行业正从单纯产品输出转向品牌与供应链出海，需加强合规准备与本土化适配以维持长期增长。（微信-厦门海外综合服务俄罗斯联络点，2026-10-10）<a href=\"/#/HomePage/editorPage?articleId=2034095\" data-title=\"（国际化、复调）中俄贸易新亮点,中国食品成对俄出口增长最快品类之一\" data-href=\"2034095\" data-index=\"5\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">5</a></li></ul></li><li><br/></li><li><br/></li><li><text style=\"font-weight:bold\" class=\"autoParse\">1.3 贸易政策与经营环境</text><ul><li><text style=\"font-weight: bold;\" class=\"autoParse\">【市场研究】全球粮食危机呈结构性恶化，厄尔尼诺加剧风险</text>：联合国世界粮食计划署指出，冲突、能源冲击与超强厄尔尼诺叠加，导致全球粮食体系面临“慢燃式”危机。预计至2027年底，新增4900万人陷入突发性粮食不安全。航运受阻推高化肥与燃料成本，进而传导至农业生产与粮价。WFP呼吁从灾后救援转向灾前行动，通过预见性援助与社会保护网降低脆弱人群风险。各国需加强本地粮食体系建设，减少对超长供应链依赖，并利用区域贸易网络增强韧性，以应对常态化的系统性扰动。（微信-澎湃新闻，2026-10-10）<a href=\"/#/HomePage/editorPage?articleId=2034090\" data-title=\"（国际化）专访世界粮食计划署司长：厄尔尼诺叠加战争影响，一场“慢燃式”粮食危机正在形成\" data-href=\"2034090\" data-index=\"6\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">6</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【区域趋势】智利企业批量抢注中国食品商标风险预警</text>：监测发现智利企业IMP. Y EXP. DE ALIMENTOS CHINAMART LIMITADA长期针对性抢注梅林、恒顺、涪陵榨菜等大量中国食品调味品商标，2026年再次集中提交30件申请。该行为具有恶意、规模化及持续性特征，部分商标已注册成功，构成出海壁垒。建议相关企业立即核查案件状态，对公示期商标提起异议，对已注册商标评估无效宣告或撤销路径。企业应树立商标先行意识，建立常态化海外监测机制，防范拉美市场品牌失守风险。（微信-注册商标，2026-10-10）<a href=\"/#/HomePage/editorPage?articleId=2033979\" data-title=\"（国际化）海外商标风险预警:智利企业批量抢注中国食品调味品品牌\" data-href=\"2033979\" data-index=\"7\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">7</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【区域趋势】缅甸FDA召回两款不合格鱼露</text>：缅甸食品药品监督管理局发布警告，要求召回“ကင်းမွန်”和“ကျားနဂါး”两款品牌鱼露。检测显示前者苯甲酸含量超标两倍多，后者氮含量低于标准且未标注生产日期。监管部门已从市场采样并责令下架，凸显当地对食品添加剂及标签合规性的监管力度。此事件提醒出口企业需严格遵守目标市场的质量标准与标签法规，避免因成分超标或标识缺失导致产品召回及市场禁入风险，确保产品合规性与安全性。（微信-凰眼观缅，2026-10-10）<a href=\"/#/HomePage/editorPage?articleId=2033982\" data-title=\"（国际化）缅甸FDA发布召回通知 两款鱼露被要求全市场下架\" data-href=\"2033982\" data-index=\"8\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">8</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【区域趋势】印度与美国香料贸易深化文化经济纽带</text>：印度驻美大使馆与美国香料贸易协会举办招待会，强调印度香料对美出口年均近7亿美元，不仅是商品贸易，更是文化纽带。美国是印度香料最大市场，依赖印度的孜然、茴香等品种。ASTA主席指出，美国本土香料种植有限，高度依赖进口，双方合作基于长期信任。随着消费者对大胆正宗风味需求增加，投资质量、食品安全及可持续农业将成为维持供应链强劲的关键，印美香料贸易有望在文化与经济双重驱动下持续增长。（South Asian Herald，2026-10-09）<a href=\"/#/HomePage/editorPage?articleId=2033987\" data-title=\"（国际化）【境外消息】印度与美国香料贸易招待会凸显文化纽带与行业合作\" data-href=\"2033987\" data-index=\"9\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">9</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【区域趋势】北美酱料市场趋向高端化与多功能化</text>：北美酱料市场呈现高端化与多功能化趋势，消费者愿为独特风味、有机认证支付溢价。甜辣组合、韩式及日式风味增长迅速，酱料被用作腌料、蘸料及餐食提升器，帮助消费者以低成本实现餐食升级。零售商通过按菜系陈列及搭配销售促进尝试。同时，无糖、清洁标签产品受到关注，如Heinz推出零添加糖盐番茄酱，满足健康需求而不牺牲口味。酱料正从单纯调味品转变为提升用餐体验的核心要素。（Canadian Grocer，2026-10-10）<a href=\"/#/HomePage/editorPage?articleId=2033998\" data-title=\"（复调、国际化）【境外消息】不止于风味：酱料是提升餐食体验的终极利器\" data-href=\"2033998\" data-index=\"10\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">10</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【区域趋势】美国FDA拒绝进口广东11批次农食产品</text>：2026年9月，美国FDA拒绝进口广东2家企业的11批次农食产品，涉及李子干、橄榄干等疑似含不安全食品添加剂环己基氨基磺酸，以及碳酸饮料标签错误和含不安全色素。这反映出美国对进口食品添加剂合规性及标签准确性的严格审查。出口企业需密切关注目标市场法规动态，确保添加剂使用符合FDA标准，并规范标签标识，避免因技术性贸易措施导致货物扣留或退回，影响出口业务稳定性。(广东省农食产品技术性贸易措施(WTO/SPS)信息平台-专题研究，2026-10-09)<a href=\"/#/HomePage/editorPage?articleId=2032938\" data-title=\"美国FDA拒绝进口广东产品情况（2026年9月）\" data-href=\"2032938\" data-index=\"11\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">11</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【市场研究】欧盟评估多种食品酶及新食品的安全性</text>：欧盟食品安全局（EFSA）近期发布多项安全性评估，包括来自非转基因菌株的食品酶磷脂酶A、亮氨酸氨基肽酶，以及转基因菌株来源的α-L-阿拉伯呋喃糖苷酶和环麦芽糊精葡聚糖转移酶。此外，还评估了苯磷硫胺作为新食品及硫胺素来源的生物利用度。这些评估旨在确保新型食品加工助剂及营养成分在欧盟市场的安全使用，反映了监管机构对食品技术创新背后潜在风险的持续监控，为相关企业进入欧洲市场提供合规依据。（欧盟食品安全局（EFSA），2026-10-07；欧盟食品安全局（EFSA），2026-10-08；欧盟食品安全局（EFSA），2026-10-09）<a href=\"/#/HomePage/editorPage?articleId=2031764\" data-title=\"（国际化）【境外消息】来自非转基因Fusarium commune菌株LFC的食品酶磷脂酶A的安全性评估==（国际化）【境外消息】含亮氨酸氨基肽酶和Xaa-Pro二肽基肽酶活性的食品酶的安全性评估，该酶源自非基因改造sp.菌株DAP 19-109==（国际化）【境外消息】关于转基因里氏木霉菌株 NZYM -GV 来源的食品用非还原性末端 α-L-阿拉伯呋喃糖苷酶使用范围扩展的安全性评估==（国际化）【境外消息】根据 Regulation (EU) 2015_2283，苯磷硫胺作为新食品的安全性，以及在 Directive 2002_46_EC 关于膳食补充剂的背景下，苯磷硫胺作为硫胺素来源的生物利用度==（国际化）【境外消息】来自基因改造 K12 菌株 DSM 34230 的食品酶环麦芽糊精葡聚糖转移酶的安全性评估\" data-href=\"2031764==2031769==2033292==2033302==2032889\" data-index=\"12==13==14==15==16\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: rgb(0, 157, 166); background-color: rgb(255, 255, 255); border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">12</a><a href=\"/#/HomePage/editorPage?articleId=2031769\" data-title=\"（国际化）【境外消息】来自非转基因Fusarium commune菌株LFC的食品酶磷脂酶A的安全性评估==（国际化）【境外消息】含亮氨酸氨基肽酶和Xaa-Pro二肽基肽酶活性的食品酶的安全性评估，该酶源自非基因改造sp.菌株DAP 19-109==（国际化）【境外消息】关于转基因里氏木霉菌株 NZYM -GV 来源的食品用非还原性末端 α-L-阿拉伯呋喃糖苷酶使用范围扩展的安全性评估==（国际化）【境外消息】根据 Regulation (EU) 2015_2283，苯磷硫胺作为新食品的安全性，以及在 Directive 2002_46_EC 关于膳食补充剂的背景下，苯磷硫胺作为硫胺素来源的生物利用度==（国际化）【境外消息】来自基因改造 K12 菌株 DSM 34230 的食品酶环麦芽糊精葡聚糖转移酶的安全性评估\" data-href=\"2031764==2031769==2033292==2033302==2032889\" data-index=\"12==13==14==15==16\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: rgb(0, 157, 166); background-color: rgb(255, 255, 255); border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">13</a><a href=\"/#/HomePage/editorPage?articleId=2033292\" data-title=\"（国际化）【境外消息】来自非转基因Fusarium commune菌株LFC的食品酶磷脂酶A的安全性评估==（国际化）【境外消息】含亮氨酸氨基肽酶和Xaa-Pro二肽基肽酶活性的食品酶的安全性评估，该酶源自非基因改造sp.菌株DAP 19-109==（国际化）【境外消息】关于转基因里氏木霉菌株 NZYM -GV 来源的食品用非还原性末端 α-L-阿拉伯呋喃糖苷酶使用范围扩展的安全性评估==（国际化）【境外消息】根据 Regulation (EU) 2015_2283，苯磷硫胺作为新食品的安全性，以及在 Directive 2002_46_EC 关于膳食补充剂的背景下，苯磷硫胺作为硫胺素来源的生物利用度==（国际化）【境外消息】来自基因改造 K12 菌株 DSM 34230 的食品酶环麦芽糊精葡聚糖转移酶的安全性评估\" data-href=\"2031764==2031769==2033292==2033302==2032889\" data-index=\"12==13==14==15==16\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: rgb(0, 157, 166); background-color: rgb(255, 255, 255); border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">14</a><a href=\"/#/HomePage/editorPage?articleId=2033302\" data-title=\"（国际化）【境外消息】来自非转基因Fusarium commune菌株LFC的食品酶磷脂酶A的安全性评估==（国际化）【境外消息】含亮氨酸氨基肽酶和Xaa-Pro二肽基肽酶活性的食品酶的安全性评估，该酶源自非基因改造sp.菌株DAP 19-109==（国际化）【境外消息】关于转基因里氏木霉菌株 NZYM -GV 来源的食品用非还原性末端 α-L-阿拉伯呋喃糖苷酶使用范围扩展的安全性评估==（国际化）【境外消息】根据 Regulation (EU) 2015_2283，苯磷硫胺作为新食品的安全性，以及在 Directive 2002_46_EC 关于膳食补充剂的背景下，苯磷硫胺作为硫胺素来源的生物利用度==（国际化）【境外消息】来自基因改造 K12 菌株 DSM 34230 的食品酶环麦芽糊精葡聚糖转移酶的安全性评估\" data-href=\"2031764==2031769==2033292==2033302==2032889\" data-index=\"12==13==14==15==16\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: rgb(0, 157, 166); background-color: rgb(255, 255, 255); border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">15</a><a href=\"/#/HomePage/editorPage?articleId=2032889\" data-title=\"（国际化）【境外消息】来自非转基因Fusarium commune菌株LFC的食品酶磷脂酶A的安全性评估==（国际化）【境外消息】含亮氨酸氨基肽酶和Xaa-Pro二肽基肽酶活性的食品酶的安全性评估，该酶源自非基因改造sp.菌株DAP 19-109==（国际化）【境外消息】关于转基因里氏木霉菌株 NZYM -GV 来源的食品用非还原性末端 α-L-阿拉伯呋喃糖苷酶使用范围扩展的安全性评估==（国际化）【境外消息】根据 Regulation (EU) 2015_2283，苯磷硫胺作为新食品的安全性，以及在 Directive 2002_46_EC 关于膳食补充剂的背景下，苯磷硫胺作为硫胺素来源的生物利用度==（国际化）【境外消息】来自基因改造 K12 菌株 DSM 34230 的食品酶环麦芽糊精葡聚糖转移酶的安全性评估\" data-href=\"2031764==2031769==2033292==2033302==2032889\" data-index=\"12==13==14==15==16\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: rgb(0, 157, 166); background-color: rgb(255, 255, 255); border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">16</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【市场研究】味好美上调通胀预期至7%</text>：味好美将2026财年通胀预期从中个位数上调至最高7%，归因于伊朗战争导致的运费上涨、美国联邦法规收紧造成的货运能力紧张，以及包装和投入成本增加。尽管通过生产力举措抵消部分压力，但预计当前季度利润率仍将受压。公司预计通胀将持续至2027年，但认为在与联合利华合并完成后，通过协同效应可在三年内降低相关成本。此预警反映了地缘政治与监管环境对全球食品供应链成本的深远影响。（Supply Chain Dive，2026-10-08）<a href=\"/#/HomePage/editorPage?articleId=2032877\" data-title=\"（国际化）【境外消息】McCormick上调通胀预期，理由是运费和投入成本上涨\" data-href=\"2032877\" data-index=\"17\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">17</a></li></ul></li><li><text style=\"font-weight:bold\" class=\"autoParse\">二、主要企业一周动向</text></li><li>本周中国食品企业国际化动态呈现合规挑战与市场拓展并存的局面。思念食品与洽洽食品被美国列入UFLPA实体清单，面临进口禁令及欧盟连锁合规风险，需重构供应链以应对地缘政治压力。卡夫亨氏推进全球分部重组并出售中国工厂，同时加码阳江酱油产能；味好美与联合利华食品合并交易通过美国初步审查，但英国监管仍在进行。颐海国际海外第三方收入大幅增长，李锦记无麸质酱油在新西兰获奖，显示品牌出海深化。此外，智利出现批量抢注中国食品商标现象，俄罗斯市场成为中国食品出口新增长点，企业需加强海外知识产权布局与本土化适配。</li><li><br/></li><li><br/></li><li><text style=\"font-weight:bold\" class=\"autoParse\">2.1 Kraft Heinz</text><ul><li><text style=\"font-weight: bold;\" class=\"autoParse\">【Kraft Heinz】【全球重组】调整分部结构并优化中国工厂布局</text>：Kraft Heinz在2026年第三季度重组全球报告结构，将新兴市场合并为单一板块，以精简运营。在中国市场，公司2025年出售了一座位于亚洲新兴市场的工厂，但同时正在报批阳江酱油厂的三期技改扩产项目，以提升原油产能满足新国标。过去十年，其全球工厂数量从87座减至69座，但单厂销售额提升19%，显示其通过外包和效率提升优化全球资产布局，北美仍是其核心基本盘。（TipRanks，2026-10-08；微信-调味品商情，2026-10-09）<a href=\"/#/HomePage/editorPage?articleId=2031738\" data-title=\"（国际化）【境外消息】卡夫亨氏推出新的全球分部报告结构==（国际化、酱油）卡夫亨氏全球工厂一张表:十年从87座减到69座\" data-href=\"2031738==2032874\" data-index=\"18==19\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">18</a><a href=\"/#/HomePage/editorPage?articleId=2032874\" data-title=\"（国际化）【境外消息】卡夫亨氏推出新的全球分部报告结构==（国际化、酱油）卡夫亨氏全球工厂一张表:十年从87座减到69座\" data-href=\"2031738==2032874\" data-index=\"18==19\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">19</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【Kraft Heinz】【高管变动】全球总法律顾问辞职</text>：Kraft Heinz宣布执行副总裁兼全球总法律顾问Angel S. Willis辞职，生效日期为2026年10月20日。这一高层变动发生在公司推进与联合利华食品业务合并的关键阶段，可能对治理连续性和利益相关者关系产生影响。公司目前正专注于整合规划及监管审批推进，以确保交易顺利完成。（TipRanks，2026-10-07）<a href=\"/#/HomePage/editorPage?articleId=2031728\" data-title=\"（国际化）【境外消息】卡夫亨氏宣布高级法务高管辞职\" data-href=\"2031728\" data-index=\"20\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">20</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【Kraft Heinz】【产品创新】进军拉面品类并推出芝士拉面</text>：Kraft Mac & Cheese品牌推出芝士拉面，这是该品牌二十年来首次进入新品类。产品将于2027年4月上市，包含鸡肉、辛辣和猪肉口味，旨在迎合年轻消费者对全球风味和健康趋势的需求。此举是CEO Steve Cahillane投入7亿美元推动创新和营销战略的一部分，旨在通过品类扩展驱动增长。（Food Dive，2026-10-06）<a href=\"/#/HomePage/editorPage?articleId=2031729\" data-title=\"（国际化）【境外消息】Kraft Mac & Cheese 数十年来首次进军新品类，推出芝士拉面\" data-href=\"2031729\" data-index=\"21\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">21</a></li></ul></li><li><text style=\"font-weight:bold\" class=\"autoParse\">2.2 McCormick</text><ul><li><text style=\"font-weight: bold;\" class=\"autoParse\">【McCormick】【并购动态】与联合利华食品合并交易通过美国初步审查</text>：McCormick收购联合利华食品业务的交易通过了美国联邦贸易委员会的等待期提前终止程序，但英国竞争与市场管理局仍在进行第一阶段调查。双方整合规划按计划推进，已组建新领导团队并签署过渡服务协议。McCormick上调2026财年通胀预期至7%， citing运费和投入成本上涨，但预计合并后将通过协同效应降低成本。交易完成后将形成一家价值约650亿美元的风味产品公司。（微信-小食代，2026-10-08；微信-农食网，2026-10-09；Supply Chain Dive，2026-10-08）<a href=\"/#/HomePage/editorPage?articleId=2032855\" data-title=\"（国际化）味好美和联合利华食品合并,CEO等高层:搞整合的人不会去干扰业务,味好美还未实际参与联合利华食品运营,交易后新团队共同敲定新计划==（复调、国际化）联合利华食品业务与McCormick交易再进一步:闯过美国程序性关卡,英国审查仍在继续==（国际化）【境外消息】McCormick上调通胀预期，理由是运费和投入成本上涨\" data-href=\"2032855==2032867==2032877\" data-index=\"22==23==17\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">22</a><a href=\"/#/HomePage/editorPage?articleId=2032867\" data-title=\"（国际化）味好美和联合利华食品合并,CEO等高层:搞整合的人不会去干扰业务,味好美还未实际参与联合利华食品运营,交易后新团队共同敲定新计划==（复调、国际化）联合利华食品业务与McCormick交易再进一步:闯过美国程序性关卡,英国审查仍在继续==（国际化）【境外消息】McCormick上调通胀预期，理由是运费和投入成本上涨\" data-href=\"2032855==2032867==2032877\" data-index=\"22==23==17\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">23</a><a href=\"/#/HomePage/editorPage?articleId=2032877\" data-title=\"（国际化）味好美和联合利华食品合并,CEO等高层:搞整合的人不会去干扰业务,味好美还未实际参与联合利华食品运营,交易后新团队共同敲定新计划==（复调、国际化）联合利华食品业务与McCormick交易再进一步:闯过美国程序性关卡,英国审查仍在继续==（国际化）【境外消息】McCormick上调通胀预期，理由是运费和投入成本上涨\" data-href=\"2032855==2032867==2032877\" data-index=\"22==23==17\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">17</a></li></ul></li><li><br/></li><li><text style=\"font-weight:bold\" class=\"autoParse\">2.3 LeeKumKee</text><ul><li><text style=\"font-weight: bold;\" class=\"autoParse\">【Lee Kum Kee】【海外获奖】无麸质酱油获新西兰健康食品指南奖项</text>：李锦记无麸质酱油在新西兰荣获Healthy Food Guide 2026年度最佳酱油奖，这是该产品首次获得此认可。该奖项由营养师评审，肯定了其简单成分和无麸质配方。李锦记大洋洲业务发展总监表示，这验证了其对质量的承诺。该产品在澳大利亚和新西兰超市持续增长，并带有新西兰乳糜泻协会认证标志，李锦记还赞助了当地的乳糜泻意识周活动。（Asia News Network，2026-10-10）<a href=\"/#/HomePage/editorPage?articleId=2034000\" data-title=\"（酱油、国际化）【境外消息】李锦记无麸质酱油荣获Healthy Food Guide 2026年度奖项\" data-href=\"2034000\" data-index=\"24\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">24</a></li><li><text style=\"font-weight: bold;\" class=\"autoParse\">【Lee Kum Kee】【海外营销】与H Mart合作开启品牌周</text>：李锦记与韩国连锁超市H Mart合作开启品牌周活动，旨在推广其亚洲酱料和调味品品牌。此次活动是李锦记在全球范围内促进中国烹饪文化的一部分，通过线下互动增强品牌在海外市场的影响力。（微信-李锦记全美味，2026-10-08）<a href=\"/#/HomePage/editorPage?articleId=2031770\" data-title=\"李锦记 x H Mart 品牌周盛大开启\" data-href=\"2031770\" data-index=\"25\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">25</a></li></ul></li><li><ul><li><br/></li></ul></li><li><br/></li><li><text style=\"font-weight:bold\" class=\"autoParse\">2.4 天味食品</text><ul><li><text style=\"font-weight: bold;\" class=\"autoParse\">【天味食品】【海外战略】推进本土化与海外大单品战略</text>：天味食品在2026—2030年五年战略中，明确国际业务推进本土化与海外大单品策略。公司坚持内生与外延并举，筹划发行H股以支持全球化布局。作为复合调味料龙头，天味食品正通过控股投资与外延并购扩张，旨在建立全链路成本管理体系，并提升其在国际市场的竞争力和品牌影响力。<a href=\"/#/HomePage/editorPage?articleId=2031870\" data-title=\"（复调、国际化）2026年中国复合调味料行业重点上市企业对比分析：颐海国际以66.13亿元营收和49.53亿元复合调味料收入居首[图]\" data-href=\"2031870\" data-index=\"26\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">26</a></li></ul></li><li><text style=\"font-weight:bold\" class=\"autoParse\">2.5 DOJO</text><ul><li><text style=\"font-weight: bold;\" class=\"autoParse\">【DOJO】【新品发布】推出日本桶陈有机酱油进军美国市场</text>：美国品牌DOJO推出由日本女性领导的家族酿酒厂酿造的桶陈酱油，采用有机大豆、小麦、海盐和山泉水，经雪松桶陈酿24个月。该产品以厨师风格挤压瓶包装上市，旨在向美国消费者重新介绍传统日本酱油的风味。DOJO通过独立精品零售商和官网销售，计划扩展更多日本主食产品线，强调工艺和创新。（Yahoo Finance，2026-10-09）<a href=\"/#/HomePage/editorPage?articleId=2032879\" data-title=\"（酱油、有机、国际化）【境外消息】DOJO 推出厨师风格挤压瓶装的日本桶陈酱油\" data-href=\"2032879\" data-index=\"27\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">27</a></li></ul></li><li><text style=\"font-weight:bold\" class=\"autoParse\">2.6 TacoBell</text><ul><li><text style=\"font-weight: bold;\" class=\"autoParse\">【Taco Bell】【跨界营销】与Duolingo合作推出多语言哈瓦那辣椒酱包</text>：Taco Bell与语言学习平台Duolingo合作，在美国、加拿大等市场推出印有九种语言的哈瓦那辣椒酱包。这款限量版酱包结合了甜味和辣味，包装上的多语言设计增加了文化相关性和收藏价值。此举旨在通过意想不到的合作伙伴关系，将日常酱料包转化为媒体对象，吸引品牌好奇的消费者并增强社交分享。（Trend Hunter，2026-10-07）<a href=\"/#/HomePage/editorPage?articleId=2032881\" data-title=\"（国际化）【境外消息】跨界酱料包：塔可钟与多邻国合作，在哈瓦那辣椒酱包上印制九种语言\" data-href=\"2032881\" data-index=\"28\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">28</a></li></ul></li><li><text style=\"font-weight:bold\" class=\"autoParse\">2.7 Mr.Ricco</text><ul><li><text style=\"font-weight: bold;\" class=\"autoParse\">【Mr. Ricco】【新品发布】推出新款辣味是拉差酱</text>：俄罗斯品牌Mr. Ricco推出新款辣味是拉差酱，适合搭配肉类、面食或作为小吃蘸料。该产品采用带分配器的包装，方便控制用量，结合了传统亚洲配方与当地偏好。此举是Mr. Ricco扩大其产品组合的一部分，旨在满足消费者对多样化辣味酱料的需求。（mrricco.ru，2026-10-09）<a href=\"/#/HomePage/editorPage?articleId=2032880\" data-title=\"（复调、国际化）【境外消息】Mr. Ricco 的新款辣味是拉差酱\" data-href=\"2032880\" data-index=\"29\" class=\"quote\" style=\"display: inline-flex; padding: 0px 6px; color: #009DA6; background-color: #ffffff; border-radius: 50%; text-align: center; margin: 0px 2px; font-size: 12px;\">29</a></li></ul></li><li><br/></li></ul><p>小Q周报由AI自动生成，使用时请注意甄别。</p></div>"
				console.log(res.data.content, 'res.data.content')
				try{
					
				
				extractedData.value = extractDataFromHTML(aiContent.value) // 调用提取函数
				if(!extractedData.value || !extractedData.value.sections || extractedData.value.sections.length === 0){
					this.showFlag.value=false 
					throw new Error('No sections found in extracted data'); 
				}
				tabs.value = extractedData.value.sections.map(section => section.title)
				tabs.value.unshift('全部') // 输出提取结果
				previewCards.value = extractedData.value.sections
				console.log(extractedData.value, 'extractedData.value')
				reloadSpinning.value = false
				showFlag.value=true
		
				toDoArticleRecord(aiCategoryId.value, 0)
				nextTick(() => {

					if (aiCategoryId.value) {
						$('.ai-category a').removeAttr('href');
						// console.log($('.ai-category').html(),'outerHTMLxixi')
						// if($('.ai-category')[0])
						// aiContent.value=$('.ai-category')[0].outerHTML;
					}
					// setOffsetTop()
				})
			   }catch{
                  showFlag.value=false
			   }
			})





		}



		const reloadSpinning = ref(false)

		const scrolldiv = ref('')


		const todayImg = ref('')
		const tabs = ref(null)
		const aiContent = ref('')

		const checkTextOverflow = (value, idx, index) => {
			if (index)
				var el = textRefs.value[value][idx][index];
			else
				var el = textRefs.value[value][idx];

			var card = null;
			console.log(value, idx, index, 'checkTextOverflow', previewCards.value)
			if (value == 0)
				card = previewCards.value[idx].children[0];
			else if (value == 1) {
				card = previewCards.value[idx].children[1].items[index];
			}
			if (!el || !card) return;
			nextTick(() => {


				// 判断是否超过3行
				const isOverflow = el.scrollHeight > el.clientHeight;
				// 更新 card.show
				card.show = isOverflow;
			});

		};


		// 切换展开/收起
		const toggleCardExpand = (value, idx, index) => {
			var card = null
			if (value == 0) {
				card = previewCards.value[idx].children[0];

			}
			else {
				card = previewCards.value[idx].children[1].items[index];
			}

			card.expanded = !card.expanded;


		};



		const toGetUserInfor = () => {

			getLoginUserInfo().then((res) => {
				store.dispatch('companyList', res.data.sysClient.companyVos[0])
				toShowDetail()
			})
		}

		const scrollY = ref(0)
		const fontSize = ref('')



		const aiCategoryId = ref(null)

		const linkList = ref([])
		const aiContentClick = (event) => {
			console.log(event, 'event')
			if (event.target.className == 'quote') {
				var list = []

				var eLinkList = event.target.attributes['data-href'].value.split("==")
				var eTitleList = event.target.attributes['data-title'].value.split("==")
				var eIndexList = event.target.attributes['data-index'].value.split("==")
				for (var i in eLinkList) {
					list.push({
						title: eTitleList[i],
						href: eLinkList[i],
						index: eIndexList[i]
					})
				}
				console.log(list, 'linkList')
				linkList.value = list
				linkArticle.value = {
					'display': 'block',
					'top': event.target.offsetTop + 'px',
					'index': 0
				}
				nextTick(() => {

					linkArticle.value.top = (event.target.offsetTop - $('.linkArticle').height() - 27) + 'px'
					linkArticle.value.index = 10
					// 创建一个选择器查询对象，.in(this)确保查询在当前页面的上下文中进行，而不是全局的上下文
					// const query = uni.createSelectorQuery().in(this);
					// var  superThis = this 
					// // boundingClientRect 会返回元素的边界信息（如宽度、高度、位置等）
					// query.select('#linkArticle').boundingClientRect(rect => {

					// 	superThis.linkArticle.top=(e.detail.y-rect.height-27)+'px'
					// 	superThis.linkArticle.index=10
					// 	}).exec();

				})

			} else linkArticle.value.display = 'none'

		}
		const linkArticle = ref({

			display: 'block',
			top: '-50px',
			index: -10


		})



		const clickLinkArticle = () => {
			return
		}
		const clickLinkArticleItem = (item) => {
			console.log(item, 'clickLinkArticleItem')
			linkArticle.value.display = 'none'
			router.push({ name: 'articleDetail', query: { articleId: item.href } })

		}
		const categoryPageClick = () => {

			linkArticle.value.display = 'none'
		}
		const toGetResize = (val, oldVal, htmlContent) => {
			if (val == oldVal) {
				aiContent.value = htmlContent;
			}
			htmlContent = htmlContent.replace(/font-size:\d{1,20}px/g, function (param) {
				var result = param.substring(param.indexOf(':') + 1, param.indexOf('p'))
				return 'font-size:' + (Number(result) + (val - oldVal) * 2) + 'px'
			})
			aiContent.value = htmlContent;
		}
		const offsetTop = ref(0)
		const collapsedList = ref([])

		// tabs and banner for 周报 列表视图

		const activeTab = ref(0)
		const scrolldivRef=ref(null)
		watch(()=>activeTab.value, (newVal) => {
			if(scrolldivRef.value)
		scrolldivRef.value.scrollTop = 0; // 切换 tab 时重置滚动条位置	
			if (newVal === 0) {
				// 显示全部
				previewCards.value.forEach(section => {
					section.sectionshow = true;
				});
			} else {
				// 显示对应的分节
				previewCards.value.forEach((section, index) => {
					section.sectionshow = index === newVal - 1;
				});
			}
		});
		const bannerTitle = ref('2026年 第32周周报')
		const dateRange = ref('08.01—08.07')
		const totalCount = ref(36)

		// 折叠控制：点击节头可以收起 / 展开
		const collapsed = ref(false)
		const toggleSection = () => { collapsed.value = !collapsed.value }

		const setOffsetTop = () => {
			var element = document.getElementsByClassName('fontResize')

			offsetTop.value = element[0].clientHeight + 'px'
		}
		// 存储 p 元素引用
		const textRefs = ref({
			0: {},
			1: {}
		});

		// ✅ 定义 setTextRef 函数
		const setTextRef = (el, value, idx, index) => {
			if (el) {
				if (index) {
					if (textRefs.value[value][idx][index]) return
					else textRefs.value[value][idx][index] = el;
				}

				else {
					if (textRefs.value[value][idx]) return
					else textRefs.value[value][idx] = el;
				}

				// 元素挂载后立即判断
				//checkTextOverflow(value, idx, index);
			}
		};


const extractDataFromHTML = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const h2s = doc.querySelectorAll('h2');
    const articleTitle = Array.from(h2s).map(h2 => h2.textContent.trim()).join('');

    const sectionsData = [];

    const rootUl = doc.querySelector('div.ai-category > ul');
    if (!rootUl) {
        // 使用 fallback 方法
        return extractWithFallback(doc, h2s);
    }

    const rootLis = rootUl.querySelectorAll(':scope > li');
    let currentSection = null;
    let sectionChildren = [];

    // ---- 检查是否包含加粗标签 ----
    function hasBoldTag(li) {
        return li.querySelector('[style*="font-weight"]') !== null;
    }

    // ---- 检查是否没有加粗标签但有内容（纯文本 或 只有 a 标签） ----
    function isPlainTextLi(li) {
        // 如果包含加粗标签，不是综合分析
        if (hasBoldTag(li)) {
            return false;
        }
        // 有内容（纯文本 或 a 标签）
        const text = li.textContent.trim();
        return text.length > 0;
    }

    function getBoldText(li) {
        const boldEl = li.querySelector('[style*="font-weight"]');
        return boldEl ? boldEl.textContent.trim().replace(/[:：]$/, '').trim() : '';
    }

    // ---- 获取内容（移除 a 标签和来源） ----
    function getContent(li) {
        const clone = li.cloneNode(true);

        // 移除加粗标签
        clone.querySelectorAll('[style*="font-weight"]').forEach(el => el.remove());
        // 移除 a 标签
        clone.querySelectorAll('a.quote').forEach(el => el.remove());
        // 移除 br 标签
        clone.querySelectorAll('br').forEach(el => el.remove());

        let content = clone.textContent.trim();

        // 去掉标题部分（冒号前的内容）
        const match = content.match(/^[^：:]*[：:]\s*/);
        if (match) {
            content = content.substring(match[0].length);
        }


//         // 移除来源
//       content = content.replace(/[（(][^）)]+[）)]/g, '').trim();
   // 声明“来源正则”
    const sourcePattern = /[（(](?:[^（）()]|[（(][^（）()]*[）)])*[，,]\s*\d{4}[-/.]\d{1,2}[-/.]\d{1,2}(?:[；;]\s*(?:[^（）()]|[（(][^（）()]*[）)])*[，,]\s*\d{4}[-/.]\d{1,2}[-/.]\d{1,2})*[）)]\s*$/;

    // 用“来源正则”删掉末尾来源
    content = content.replace(sourcePattern, '');
        // 清理多余空白
        content = content.replace(/\s+/g, ' ').trim();

        return content;
    }

    // ---- 提取 a 标签，删除 href 属性 ----
    function extractLinksHtml(htmlString) {
        if (!htmlString) return '';
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        const aTags = tempDiv.querySelectorAll('a.quote');
        if (aTags.length === 0) return '';
        return Array.from(aTags).map(a => {
            const clone = a.cloneNode(true);
            clone.removeAttribute('href');
            return clone.outerHTML;
        }).join('');
    }

    // ---- 修正：支持多个来源用分号连接 ----
function extractSources(text) {
    if (!text) return [];
    const sources = [];

    const sourcePattern = /[（(]((?:[^（）()]|[（(][^（）()]*[）)])*?)[，,]\s*(\d{4}[-/.]\d{1,2}[-/.]\d{1,2})((?:[；;]\s*(?:[^（）()]|[（(][^（）()]*[）)])*?[，,]\s*\d{4}[-/.]\d{1,2}[-/.]\d{1,2})*)[）)]/g;
    const restPattern = /[；;]\s*((?:[^（）()]|[（(][^（）()]*[）)])*?)[，,]\s*(\d{4}[-/.]\d{1,2}[-/.]\d{1,2})/g;

    let match;
    while ((match = sourcePattern.exec(text)) !== null) {
        sources.push({ title: match[1].trim(), time: match[2].trim() });

        const rest = match[3];
        if (rest) {
            restPattern.lastIndex = 0;
            let m;
            while ((m = restPattern.exec(rest)) !== null) {
                sources.push({ title: m[1].trim(), time: m[2].trim() });
            }
        }
    }

    return sources;
}

    function cleanLevel1Title(text) {
        return text.replace(/^[一二三四五六七八九十]、\s*/, '');
    }

    function isLevel1(text) {
        return /^[一二三四五六七八九十]、/.test(text);
    }

    function isSummary(text) {
        return text === '综合分析';
    }

    for (let i = 0; i < rootLis.length; i++) {
        const li = rootLis[i];
        const boldText = getBoldText(li);
        const hasBold = hasBoldTag(li);
        const isPlainText = isPlainTextLi(li);
        const innerText = li.textContent.trim();

        console.log(`li[${i}] boldText:`, boldText, 'hasBold:', hasBold, 'isPlainText:', isPlainText);

        // ---- 情况：没有加粗标签，有内容 → 综合分析 ----
        if (isPlainText && innerText && !hasBold) {
            if (currentSection) {
                // 检查是否已经添加过综合分析
                const hasSummary = sectionChildren.some(child => child.tag === '综合分析' || child.tag === '');
                if (!hasSummary) {
                    const originalHtml = li.innerHTML;
                    const content = getContent(li);
                    sectionChildren.push({
                        tag: '综合分析',
                        subTitle: '',
                        content: content || innerText,
                        links: extractLinksHtml(originalHtml),
                        sources: extractSources(originalHtml || innerText)
                    });
                }
            }
            continue;
        }

        if (!boldText) continue;

        // ---- 一级标题 ----
        if (isLevel1(boldText)) {
            if (currentSection) {
                currentSection.children = sectionChildren;
                sectionsData.push(currentSection);
            }

            currentSection = {
                title: cleanLevel1Title(boldText),
                preTitle: boldText,
                children: [],
                show: false,
                sectionshow: true
            };
            sectionChildren = [];

            const nextLi = rootLis[i + 1];
            if (nextLi) {
                const nextBold = getBoldText(nextLi);
                const nextIsPlainText = isPlainTextLi(nextLi);
                const nextInnerText = nextLi.textContent.trim();
                const nextHasBold = hasBoldTag(nextLi);

                // 下一个 li 是综合分析（没有加粗标签但有内容）或有"综合分析"标签
                if (nextIsPlainText && nextInnerText && !nextHasBold) {
                    const originalHtml = nextLi.innerHTML;
                    const content = getContent(nextLi);
                    sectionChildren.push({
                        tag: '综合分析',
                        subTitle: '',
                        content: content || nextInnerText,
                        links: extractLinksHtml(originalHtml),
                        sources: extractSources(originalHtml || nextInnerText)
                    });
                    i++;
                    continue;
                } else if (isSummary(nextBold)) {
                    const originalHtml = nextLi.innerHTML;
                    const content = getContent(nextLi);
                    sectionChildren.push({
                        tag: nextBold,
                        subTitle: '',
                        content: content,
                        links: extractLinksHtml(originalHtml),
                        sources: extractSources(originalHtml)
                    });
                    i++;
                    continue;
                }
            }
            continue;
        }

        // ---- 二级标题 ----
        if (currentSection && !isSummary(boldText)) {
            const innerUl = li.querySelector(':scope > ul');

            if (innerUl) {
                const subTitle = boldText;
                const items = [];

                const subLis = innerUl.querySelectorAll(':scope > li');
                for (const subLi of subLis) {
                    const subBold = getBoldText(subLi);
                    if (!subBold) {
                        const originalHtml = subLi.innerHTML;
                        const content = getContent(subLi);
                        if (content) {
                            items.push({
                                tag: '',
                                title: '',
                                content,
                                links: extractLinksHtml(originalHtml),
                                sources: extractSources(originalHtml)
                            });
                        }
                        continue;
                    }

                    const tagMatch = subBold.match(/【([^】]+)】/);
                    const tag = tagMatch ? tagMatch[1] : '';
                    const itemTitle = subBold.replace(/【[^】]+】/, '').trim();
                    const originalHtml = subLi.innerHTML;
                    const content = getContent(subLi);

                    if (itemTitle || content) {
                        items.push({
                            tag,
                            title: itemTitle,
                            content,
                            links: extractLinksHtml(originalHtml),
                            sources: extractSources(originalHtml)
                        });
                    }
                }

                if (items.length > 0) {
                    sectionChildren.push({ subTitle, items, subTitleShow: true });
                }
            }
        }
    }

    if (currentSection) {
        currentSection.children = sectionChildren;
        sectionsData.push(currentSection);
    }

    // 如果 sectionsData 为空，使用 fallback 方法
    if (sectionsData.length === 0) {
        return extractWithFallback(doc, h2s);
    }

    return { articleTitle, sections: sectionsData };
};

/**
 * Fallback 提取方法 - 处理 ul > li 结构，支持多个一级标题
 */
/**
 * Fallback 提取方法 - 处理 ul > li 结构，支持多个一级标题
 * 每个 section 对应一个 h2 标题（如 1.行业趋势与品类变化）
 */
/**
 * Fallback 提取方法 - 处理 ul > li 结构，支持多个一级标题
 * 每个 section 对应一个 h2 标题（如 1.行业趋势与品类变化）
 */
function extractWithFallback(doc, h2s) {
    let articleTitle = '';
    const sections = [];

    const h2Array = Array.from(h2s);

    if (h2Array.length > 0) {
        articleTitle = h2Array[0].textContent.trim();
    }

    const sectionH2s = [];
    for (let i = 0; i < h2Array.length; i++) {
        const text = h2Array[i].textContent.trim();
        if (!text.includes('周报') && text) {
            sectionH2s.push({
                index: i,
                title: text,
                element: h2Array[i]
            });
        }
    }

    if (sectionH2s.length === 0) {
        for (let i = 1; i < h2Array.length; i++) {
            const text = h2Array[i].textContent.trim();
            if (text) {
                sectionH2s.push({
                    index: i,
                    title: text,
                    element: h2Array[i]
                });
            }
        }
    }

    function extractLinksHtml(el) {
        if (!el) return '';
        const links = [];
        const aTags = el.querySelectorAll('a.quote');
        aTags.forEach(a => {
            const clone = a.cloneNode(true);
            clone.removeAttribute('href');
            links.push(clone.outerHTML);
        });
        return links.join('');
    }

    function extractSources(text) {
        if (!text) return [];
        const sources = [];
        const multiRegex = /[（(]([^）)]+)[）)]/g;
        let match;
        while ((match = multiRegex.exec(text)) !== null) {
            const content = match[1];
            const parts = content.split(/[；;]\s*/);
            for (const part of parts) {
                let itemMatch = part.match(/^([^，,]+)[，,]\s*(\d{4}-\d{2}-\d{2})/);
                if (!itemMatch) {
                    itemMatch = part.match(/^(.+?)\s+(\d{4}-\d{2}-\d{2})$/);
                }
                if (itemMatch) {
                    sources.push({
                        title: itemMatch[1].trim(),
                        time: itemMatch[2].trim()
                    });
                }
            }
        }
        if (sources.length === 0) {
            const regex = /[（(]([^，,）)]+)[，,]\s*(\d{4}-\d{2}-\d{2})[）)]/g;
            while ((match = regex.exec(text)) !== null) {
                sources.push({
                    title: match[1].trim(),
                    time: match[2].trim()
                });
            }
            const regexSpace = /[（(](.+?)\s+(\d{4}-\d{2}-\d{2})[）)]/g;
            while ((match = regexSpace.exec(text)) !== null) {
                const exists = sources.some(s => s.title === match[1].trim() && s.time === match[2].trim());
                if (!exists) {
                    sources.push({
                        title: match[1].trim(),
                        time: match[2].trim()
                    });
                }
            }
        }
        return sources;
    }

    sectionH2s.forEach((sectionH2, idx) => {
        const cleanTitle = sectionH2.title.replace(/^\d+\.\s*/, '');

        let ulElement = null;
        let next = sectionH2.element.nextElementSibling;
        while (next) {
            if (next.tagName === 'UL') {
                ulElement = next;
                break;
            }
            next = next.nextElementSibling;
        }

        if (!ulElement) {
            const allUls = doc.querySelectorAll('ul');
            if (idx < allUls.length) {
                ulElement = allUls[idx];
            }
        }

        if (ulElement && ulElement.tagName === 'UL') {
            const topLevelLis = ulElement.querySelectorAll(':scope > li');
            const children = [];

            topLevelLis.forEach(topLi => {
                const contentUl = topLi.querySelector(':scope > ul');
                const hasChildUl = !!contentUl;

                if (hasChildUl && contentUl) {
                    let subTitle = '';
                    const boldTextEl = topLi.querySelector(':scope > text[style*="font-weight:bold"]');
                    if (boldTextEl) {
                        subTitle = boldTextEl.textContent.trim();
                    }
                    if (!subTitle) {
                        const boldTextEl2 = topLi.querySelector(':scope > b > text[style*="font-weight:bold"]');
                        if (boldTextEl2) {
                            subTitle = boldTextEl2.textContent.trim();
                        }
                    }
                    if (!subTitle) {
                        const allBold = topLi.querySelectorAll('[style*="font-weight:bold"]');
                        if (allBold.length > 0) {
                            subTitle = allBold[0].textContent.trim();
                        }
                    }
                    if (!subTitle) {
                        const textEl = topLi.querySelector(':scope > text');
                        if (textEl) {
                            subTitle = textEl.textContent.trim().replace(/\s*\d+\s*$/, '').trim();
                        }
                    }

                    const items = [];
                    const contentLis = contentUl.querySelectorAll(':scope > li');
                    contentLis.forEach(li => {
                        let title = '';
                        const titleEl = li.querySelector('b > text');
                        if (titleEl) {
                            title = titleEl.textContent.trim().replace(/\s+/g, ' ');
                        }
                        if (!title) {
                            const boldEl = li.querySelector('[style*="font-weight"]');
                            if (boldEl) {
                                title = boldEl.textContent.trim().replace(/\s+/g, ' ');
                            }
                        }
                        if (!title) {
                            const textEl = li.querySelector(':scope > text');
                            if (textEl) {
                                title = textEl.textContent.trim().replace(/\s+/g, ' ');
                            }
                        }

                        const clone = li.cloneNode(true);
                        clone.querySelectorAll('b').forEach(el => el.remove());
                        clone.querySelectorAll('[style*="font-weight"]').forEach(el => el.remove());
                        clone.querySelectorAll('a.quote').forEach(el => el.remove());
                        clone.querySelectorAll('br').forEach(el => el.remove());
                        let content = clone.textContent.trim().replace(/\s+/g, ' ');
                        if (title && content.startsWith(title)) {
                            content = content.substring(title.length).trim();
                        }
                        content = content.replace(/^[：:]\s*/, '').trim();

                        const links = extractLinksHtml(li);
                        const sources = extractSources(li.innerHTML || content);

                        if (title || content) {
                            items.push({
                                tag: '',
                                title: title || '',
                                content: content || '',
                                links: links,
                                sources: sources,
                                expanded: false,
                                showExpandBtn: false
                            });
                        }
                    });

                    if (items.length > 0) {
                        children.push({
                            subTitle: subTitle || '',
                            items: items,
                            subTitleShow: true
                        });
                    }
                } else {
                    const items = [];
                    const textEls = topLi.querySelectorAll(':scope > text');
                    textEls.forEach(textEl => {
                        let title = textEl.textContent.trim().replace(/\s*\d+\s*$/, '').trim();
                        if (title) {
                            let links = '';
                            let sources = [];
                            let content = '';
                            
                            // ---- 关键修复：从 topLi 的完整文本中提取 content ----
                            const fullText = topLi.textContent || '';
                            let contentText = fullText.replace(title, '').trim();
                            contentText = contentText.replace(/\s*\d+\s*$/, '').trim();
                            // contentText = contentText.replace(/[（(][^）)]+[）)]/g, '').trim();
							contentText = contentText.replace(/[（(](?:[^（）()]|[（(][^（）()]*[）)])*?[，,]\s*\d{4}[-/.]\d{1,2}[-/.]\d{1,2}(?:[；;]\s*(?:[^（）()]|[（(][^（）()]*[）)])*?[，,]\s*\d{4}[-/.]\d{1,2}[-/.]\d{1,2})*[）)]\s*$/, '').trim();

                            contentText = contentText.replace(/^[：:]\s*/, '').trim();
                            content = contentText.replace(/\s+/g, ' ').trim();
                            
                            const nextSibling = textEl.nextElementSibling || textEl.nextSibling;
                            if (nextSibling && nextSibling.tagName === 'A') {
                                const classAttr = nextSibling.className || '';
                                if (classAttr && classAttr.includes('quote')) {
                                    const clone = nextSibling.cloneNode(true);
                                    clone.removeAttribute('href');
                                    links = clone.outerHTML;
                                    sources = extractSources(nextSibling.outerHTML || nextSibling.textContent || '');
                                }
                            }
                            
                            items.push({
                                tag: '',
                                title: title,
                                content: content || '',
                                links: links,
                                sources: sources,
                                expanded: false,
                                showExpandBtn: false
                            });
                        }
                    });

                    if (items.length > 0) {
                        children.push({
                            subTitle: '',
                            items: items,
                            subTitleShow: true
                        });
                    }
                }
            });

            if (children.length > 0) {
                sections.push({
                    title: cleanTitle,
                    preTitle: sectionH2.title,
                    children: children,
                    show: false,
                    sectionshow: true
                });
            }
        } else {
            sections.push({
                title: cleanTitle,
                preTitle: sectionH2.title,
                children: [],
                show: false,
                sectionshow: true
            });
        }
    });

    if (sections.length === 0) {
        for (let i = 1; i < h2Array.length; i++) {
            const h2 = h2Array[i];
            const text = h2.textContent.trim();
            if (text) {
                const cleanTitle = text.replace(/^\d+\.\s*/, '');
                sections.push({
                    title: cleanTitle,
                    preTitle: text,
                    children: [],
                    show: false,
                    sectionshow: true
                });
            }
        }
    }

    return {
        articleTitle: articleTitle,
        sections: sections
    };
}

const  toCopy=async()=>{
	 const { toClipboard } = useClipboard()

        var contentC = aiContent.value
      

            //删除a标签
            contentC = contentC.replace(/<a[^>]*>.*?<\/a>/g, '')
            console.log(contentC, '周报内容')

            contentC =  contentC.replace(/<\/?(?:span|text|strong)[^>]*>/g, '')



          contentC = contentC.replace(/<img [^\>]*\/>/g, '')

          contentC = contentC.replace(/<[^>]+>/g, "\n")
          contentC = contentC.replace(/\n+/g, '\n')
        contentC=contentC.replace(/&nbsp;/g, '')
         
       
        try {

          await toClipboard(contentC.trim())
          message.success('复制成功', 10);
        } catch (err) {
          console.error('复制失败:', err);
          message.error('复制失败，请手动复制', 10);
        }
     
}

		return {
			toCopy,
			showFlag,
			scrolldivRef,
			toggleCardExpand,
			setTextRef,
			textRefs,
			setOffsetTop,
			offsetTop,

			toGetResize,
			linkArticle,

			clickLinkArticle,
			clickLinkArticleItem,

			linkList,

			aiContent,
			aiCategoryId,
			aiContentClick,
			linkSrc: 'https://enplus.oss-cn-guangzhou.aliyuncs.com/file/ea4d857a-0283-42db-b265-92658fc03803.png',
			categoryPageClick,
			fontSize,
			scrollY,

			toGetUserInfor,
			todayImg,

			scrolldiv,

			reloadSpinning,

			// UI 控制：tabs / banner
			tabs,
			activeTab,
			bannerTitle,
			dateRange,
			totalCount,
			// 折叠状态与切换方法
			collapsed,
			toggleSection,

			previewCards,
			extractedData
		}
	},
	beforeRouteLeave(to, from, next) {
		if (to.path == '/INT' || to.path == '/main') {
			this.scrollY = 0
		}
		else
			//保存滚动条元素div的scrollTop值
			this.scrollY = document.querySelector('.scrolldiv').scrollTop
		next();
	},
}
</script>
<style lang="scss" scoped>
@import '../../assets/style.scss';
.weekscroll{
	display: block !important;
	
}
.banner-area{
	 box-shadow: 0 8px 20px rgba(16, 24, 40, 0.06); position: sticky;  top: 0;   z-index: 100;background-color: white;padding:15px 40px 0px 40px 
}

.page-container {
	background: #f7f7f7;
	min-height: 100vh;
	padding: 0px 0px 40px 0px !important;
	width: 100%;
}


.ubutton-class {
	padding: 0 10px !important;
	border: none !important;
	cursor: pointer;

	.u-hairline-border::after {
		border: none !important;
	}
}

.introduce {
	color: #888e90;
	cursor: pointer;
	font-size: 15px;
	line-height: 22px;
	text-overflow: ellipsis;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 4;
	line-clamp: 4;
	-webkit-box-orient: vertical;
	padding: 0px 12px 0px 12px;
	text-align: justify;
}

.introduceSmall {
	font-size: 13px !important;
}

.introduceBig {
	font-size: 17px !important;
}

.inline-content {
	cursor: pointer;
}

.inline-content {
	a {
		color: rgba(0, 0, 0, 0.9);
	}


}

.inline-content:hover {
	a {
		color: #315efb !important;
	}

}

.introduce:hover {
	color: #babcbc !important;

}

.scrolldiv {
	justify-content: center;
	display: flex;
}

.catalog-article-detail {


	.home {
		margin-left: 24px;
		width: 48px;
		height: 48px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;

		.home-img {
			width: 48px;
			height: 48px;
		}
	}

	.detail {
		padding: 20px 20px 80px;
		font-size: 24px;

		position: relative;

		.powerby {


			.powerby-image {
				width: 100%;
			}
		}










	}
}


.linkArticle {
	display: none;
	background-color: white;

	position: absolute;
	color: #009DA6;
	left: 0;
	right: 0;
	overflow-y: auto;
	margin: auto;
	max-height: 300px;
	width: 90%;
	padding: 10px 10px;
	border-radius: 10px;
	box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}


.linkItem {
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 15px;
	line-height: 30px;
	width: 95%;
	cursor: pointer
}

.linkItem:hover {
	color: #1890ff;
}

/* 新增：符合图片视觉的头部、横幅与标签样式 */
.header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 16px;
	background: #fff;
	position: sticky;
	top: 0;
	z-index: 30;
	border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.header .back {
	font-size: 22px;
	cursor: pointer;
}

.header .title {
	font-size: 18px;
	font-weight: 600;
}

.header .actions {
	display: flex;
	gap: 8px;
	align-items: center;
	color: #333;
}

// .content-wrap {
// 	width: 80%;
// 	margin: 16px auto;
// }

.banner-card {
	display: flex;
    align-items: center;
    background-image: url(https://enplus.oss-cn-guangzhou.aliyuncs.com/file/96e1ef3e-2e4f-45be-b328-525db0bb8e0f.png);
    border-radius: 12px;
    padding: 10px;
    box-shadow: none;
    background-repeat: unset;
    background-size: cover;
    background-position: center;
}

.banner-left {
	margin-right: 12px
}

.icon-round {
	    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #E3F4F3;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.icon-round img {
	    width: 30px;
    height: 30px;
}

.banner-right {
	flex: 1
}

.banner-title {
	font-size: 18px;
	font-weight: 700;
	color: #083333
}

.banner-sub {
	color: #5b7b7a;
	margin-top: 6px
}

.tabs {
    display: flex;
    gap: 24px;
    padding: 10px 6px;
    background: #fff;
    overflow-x: auto;
    border-bottom: 1px solid #f0f0f0;
}
.tab:hover{
  color: #0aa39a;

}

.tab {
	padding: 8px 4px;
	color: #6b6b6b;
	cursor: pointer;
	position: relative
}

.tab.active {
	color: #0aa39a;
	font-weight: 600
}

.tab.active::after {
	    content: "";
    height: 3px;
    // width: 24px;
    background: #0aa39a;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -10px;
    margin: 0 auto;
    border-radius: 2px;
}

.list-area {
	padding: 12px 0
}

.section .card {
	background: #fff;
	border-radius: 10px;
	padding: 16px;
	margin-bottom: 16px;
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06)
}



/* 调整 list-area / section 样式以匹配设计图 */
.list-area {
	padding: 18px 0 40px;
	position: relative;
}

.section-block {
	margin-top: 18px;
}

.section-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 14px;
	background: transparent;
}

.section-left {
	display: flex;
	align-items: center;
	gap: 12px;
	width: 100%;
}

.section-left .mark {
	width: 6px;
	height: 28px;
	background: #10a39a;
	border-radius: 4px;
}

.section-left .section-index {
	color: #0b2b2b;
	font-weight: 700;
	font-size: 14px
}

.section-left .section-title-text {
	font-size: 18px;
	font-weight: 700;
	color: #0b2b2b
}

.section-right {
	display: flex;
	align-items: center;
	gap: 12px
}

.section-right .section-sub {
	color: #9aa9a8;
	font-size: 13px
}

.collapse-icon {
	font-size: 18px;
	color: #333
}

.cards-container {
	margin-top: 10px
}

.cards-inner .report-card {
	background: #fff;
	border-radius: 12px;
	padding: 18px 18px 14px;
	margin-bottom: 16px;
	box-shadow: 0 8px 20px rgba(16, 24, 40, 0.06);
	border: 1px solid rgba(15, 34, 32, 0.04);
	overflow: hidden;
}

.cards-inner .report-card .pill-tag,
.cards-inner .report-card .tag {
	background: #e9f7f6;
	color: #0a9f97;
	padding: 6px 6px;
	border-radius: 8px;
	font-size: 13px;
	margin-right: 12px;
	border: 1px solid #0a9f97;
}

.card-title {
	font-weight: bolder;
	font-size: 16px;
	line-height: 2;
	text-align: justify;
}

.cards-inner .report-card h3,
.cards-inner .report-card strong {
	font-size: 18px;
	font-weight: 700;
	color: #0b2b2b
}

.cards-inner .report-card p {
	color: #555;
	line-height: 1.8;
	margin-top: 12px;
	// overflow: hidden;
	// display: -webkit-box;
	// -webkit-line-clamp: 3;
	// -webkit-box-orient: vertical;
	// max-height: calc(1.8em * 3 + 12px);
}

/* 将展开按钮居中并样式化 */
.expand-btn {
	display: inline-block;
	background: #e8faf9;
	color: #0aa39a;
	padding: 8px 14px;
	border-radius: 18px;
	margin: 12px auto 0;
	border: none;
	text-decoration: none;
	cursor: pointer;
	user-select: none;
	display: block;
	width: max-content;
}

.expand-btn::after {
	content: ' ↓';
	font-size: 12px;
	margin-left: 4px
}

.disexpand-btn::after {
	content: ' ↑';
	font-size: 12px;
	margin-left: 4px
}

/* 卡片展开时移除段落高度限制 */
.cards-inner .report-card {
	transition: box-shadow .18s ease
}

.cards-inner .expanded {
	box-shadow: 0 12px 30px rgba(16, 24, 40, 0.08)
}

.cards-inner .expanded p {
	/* 取消多行截断样式，恢复正常块级流排布，避免按钮与文本重叠 */
	display: block !important;
	-webkit-line-clamp: unset !important;
	-webkit-box-orient: unset !important;
	max-height: none !important;
	overflow: visible !important;
}

/* 确保展开按钮位于段落下方并居中 */
.expand-btn {
	display: block !important;
	margin: 12px auto 0 !important;
	clear: both;
	z-index: 1;
}

/* 卡片底部 meta */
.cards-inner .report-card .meta {
	display: flex;
	gap: 12px;
	color: #9aa9a8;
	margin-top: 14px;
	font-size: 13px;
	align-items: center;
	border-top: 1px solid;
	padding-top: 10px;
	    flex-wrap: wrap;
}

.cards-inner .report-card .meta .dot {
	width: 4px;
	height: 4px;
	background: #cfdcdc;
	border-radius: 50%;
	display: inline-block;
	margin: 0 6px
}
</style>
<style lang="less">
.ai-category {
	padding: 0px 32px 32px 32px;
	line-height: 36px !important;

	ul {
		list-style-type: disc;
		padding-left: 2em;
	}

	.quote {
		line-height: 12px !important;
	}

	ul ul {
		list-style-type: circle;
	}

	h2 {
		font-weight: bold;

		strong {
			font-weight: bold;
			color: #595959;
		}
	}


}

</style>
